import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import * as styles from './FormAccordionSection.scss';

var FormAccordionSection = /*#__PURE__*/function (_Component) {
  _inherits(FormAccordionSection, _Component);

  var _super = _createSuper(FormAccordionSection);

  function FormAccordionSection(props) {
    var _this;

    _classCallCheck(this, FormAccordionSection);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "toggleSection", function () {
      _this.setState({
        showSectionContent: !_this.state.showSectionContent
      });
    });

    _this.state = {
      showSectionContent: props.open
    };
    return _this;
  }

  _createClass(FormAccordionSection, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          toggleLabel = _this$props.toggleLabel,
          children = _this$props.children;
      return /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12 ".concat(styles.formSection)
      }, /*#__PURE__*/React.createElement("h4", {
        style: {
          opacity: this.state.showSectionContent ? '1' : '0.7'
        },
        className: styles.toggleLabel,
        onClick: this.toggleSection
      }, toggleLabel, this.state.showSectionContent ? /*#__PURE__*/React.createElement("i", {
        className: "icon ion-ios-arrow-up ".concat(styles.downArrow)
      }) : /*#__PURE__*/React.createElement("i", {
        className: "icon ion-ios-arrow-down ".concat(styles.downArrow)
      })), /*#__PURE__*/React.createElement(ReactCSSTransitionGroup, {
        component: "div",
        transitionName: "slidedown",
        transitionEnterTimeout: 300,
        transitionLeaveTimeout: 300
      }, this.state.showSectionContent && /*#__PURE__*/React.createElement("div", {
        className: styles.contentWrap
      }, children)));
    }
  }]);

  return FormAccordionSection;
}(Component);

_defineProperty(FormAccordionSection, "propTypes", {
  children: PropTypes.node.isRequired,
  open: PropTypes.bool
});

_defineProperty(FormAccordionSection, "defaultProps", {
  open: false
});

export { FormAccordionSection as default };